import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProjectService } from '../../_services/project.service';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { AdminService } from '../../_services/admin.service';
import { Observable } from 'rxjs/Rx';

import { EditParticularsDialogComponent } from '../edit-particulars/edit-particulars.component';

import {
    trigger,
    state,
    query,
    style,
    animate,
    transition
} from '@angular/animations';

@Component({
    selector: 'app-current',
    templateUrl: './current.component.html',
    styleUrls: ['./current.component.less'],
    animations: [
        trigger('collapse', [
            state('void', style({ height: '0px' })),
            transition(':enter', animate('150ms ease-in', style({ height: '*' }))),
            transition(':leave', animate('200ms ease-out', style({ height: '0px' })))
        ])
    ]
})
export class CurrentComponent implements OnInit {

    config: MatDialogConfig = {
        disableClose: false,
        hasBackdrop: true,
        backdropClass: '',
        width: '500px',
        height: '',
        position: {
            top: '',
            bottom: '',
            left: '',
            right: ''
        }
    };

    private currentYear: number;
    private years = [];
    private portId: number;
    private slug: string;
    private facilities: any;
    private state: any = {};
    private mapType: string;
    private mapTypeId: number;

    private projects: any;
    private projectTypes = [];
    private projectType: any;
    private projectTypeId: number;

    constructor(private projectService: ProjectService, private adminService: AdminService, private activatedRoute: ActivatedRoute, private dialog: MatDialog) {
        this.activatedRoute.params.subscribe(params => {
            this.portId = parseInt(params['portId']);
            this.slug = params['slug'];
        });

        this.activatedRoute.url.subscribe(url => {
            let currentUrl = window.location.href;
            let lastSlash = currentUrl.lastIndexOf('/') + 1;
            this.mapType = currentUrl.substr(lastSlash);
            this.mapTypeId = this.mapType == 'planning' ? 0 : this.mapType == 'navigation' ? 1 : 2;

            this.adminService.get('projects/types').subscribe(response => {
                let getProjectTypesResult = response.json().Result;
                let projectTypes = getProjectTypesResult.ProjectTypes;
                projectTypes.forEach((type) => {
                    if (type.Color == null) type.Color = '#000000';
                    else type.Color = '#' + type.Color;
                });

                this.projectTypes = projectTypes;
            });
        });
    }

    ngOnInit() {
        this.currentYear = new Date().getFullYear();
        this.years.push(this.currentYear);
    }

    loadProjects() {
        this.projectService.getCurrentProjects(this.portId, this.mapTypeId, this.projectTypeId)
            .subscribe(response => {
                let result = response.json().Result;

                if (this.mapTypeId != 1) {
                    this.facilities = result.Facilities;
                    this.facilities.forEach(facility => {
                        facility.collapse = false;

                        facility.Facilities.forEach(child => {
                            child.collapse = false;
                            child.Projects = this._transformProjects(child.Projects);
                            child.Children.forEach(child => {
                                child.collapse = false;
                                child.Projects = this._transformProjects(child.Projects);

                                child.Children.forEach(child => {
                                    child.Projects = this._transformProjects(child.Projects);
                                });
                            });
                        });
                    });

                    return;
                }

                let yearProjects = {};
                this.years.forEach(year => {
                    yearProjects[year] = [];
                });

                let projects = result.Projects;
                projects.forEach(project => {
                    yearProjects[project.Year].push(project);
                });

                this.projects = yearProjects;
            });
    }

    editFacility(facility: any) {
        this.config.data = { facility: facility };

        let opened = this.dialog.open(EditParticularsDialogComponent, this.config);
        opened.afterClosed().subscribe(result => {
            if (result != null) {
                facility.ParticularsToDate = result.ParticularsToDate;
            }

            this.config.data = {};
        });

        return false;
    }

    _transformProjects(projects: any) {
        let transformed = {};
        this.years.forEach(year => transformed[year] = []);

        projects.forEach(project => {
            if (transformed[this.currentYear] == null) {
                transformed[this.currentYear] = [];
            }

            transformed[this.currentYear].push(project);
        });

        return transformed;
    }

    filterProjects() {
        this.projectType = this.getProjectType(this.projectTypeId);
        this.loadProjects();
    }

    getProjectType(id: number) {
        return this.projectTypes.find((type) => type.Id == id);
    }
}



// WEBPACK FOOTER //
// ./Angular/app/projects/current/current.component.ts